import React from 'react';

const Input = ({ 
  label, 
  error, 
  helperText, 
  icon,
  className = '',
  fullWidth = true,
  ...props 
}) => {
  const inputStyles = {
    width: fullWidth ? '100%' : 'auto',
    padding: icon ? '10px 14px 10px 40px' : '10px 14px',
    background: 'rgba(7, 6, 11, 0.75)',
    border: `2px solid ${error ? 'var(--color-error)' : 'var(--color-border)'}`,
    borderRadius: 'var(--radius-md)',
    color: 'var(--color-text-primary)',
    fontSize: 'var(--text-md)',
    outline: 'none',
    transition: 'border-color var(--transition-fast), box-shadow var(--transition-fast)',
    fontFamily: 'var(--font-body)'
  };

  const labelStyles = {
    display: 'block',
    fontSize: 'var(--text-xs)',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: 'var(--loud-lime)',
    marginBottom: '8px',
    fontFamily: 'var(--font-display)'
  };

  const containerStyles = {
    width: fullWidth ? '100%' : 'auto',
    position: 'relative'
  };

  const iconContainerStyles = {
    position: 'absolute',
    left: '12px',
    top: label ? 'calc(50% + 10px)' : '50%',
    transform: 'translateY(-50%)',
    color: '#9ca3af',
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'none'
  };

  const errorStyles = {
    marginTop: '6px',
    fontSize: 'var(--text-sm)',
    color: 'var(--color-error, #fca5a5)',
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  };

  const helperStyles = {
    marginTop: '6px',
    fontSize: 'var(--text-sm)',
    color: 'var(--color-text-muted, #9ca3af)'
  };

  const handleFocus = (e) => {
    e.target.style.borderColor = error ? 'var(--color-error)' : 'var(--loud-orange)';
    e.target.style.boxShadow = error
      ? '0 0 0 4px rgba(255, 77, 109, 0.18)'
      : '0 0 0 4px rgba(255, 90, 31, 0.18)';
  };

  const handleBlur = (e) => {
    e.target.style.borderColor = error ? 'var(--color-error)' : 'var(--color-border)';
    e.target.style.boxShadow = 'none';
  };

  const inputId = props.id || `input-${Math.random().toString(36).slice(2, 9)}`;
  const errorId = `${inputId}-error`;
  const helperId = `${inputId}-helper`;

  return (
    <div style={containerStyles}>
      {label && (
        <label htmlFor={inputId} style={labelStyles}>
          {label}
          {props.required && <span style={{ color: '#fca5a5', marginLeft: '4px' }} aria-label="required">*</span>}
        </label>
      )}
      <div style={{ position: 'relative' }}>
        {icon && (
          <div style={iconContainerStyles} aria-hidden="true">
            {icon}
          </div>
        )}
        <input
          {...props}
          id={inputId}
          style={inputStyles}
          className={className}
          onFocus={handleFocus}
          onBlur={handleBlur}
          aria-invalid={!!error}
          aria-describedby={
            error ? errorId : helperText ? helperId : undefined
          }
        />
      </div>
      {error && (
        <p id={errorId} role="alert" style={errorStyles}>
          <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          {error}
        </p>
      )}
      {helperText && !error && (
        <p id={helperId} style={helperStyles}>{helperText}</p>
      )}
    </div>
  );
};

export default Input;
